module.exports = __webpack_public_path__ + "static/media/golf-mk-5-suspension.a7a5fcc7.jpg";